/* eslint-disable camelcase */
import * as yup from 'yup';

export const schema = yup.object({
  full_name: yup
    .string()
    .required('La cantidad de caracteres ingresados es inválida')
    .min(3, 'La cantidad de caracteres ingresados es inválida')
    .matches(
      /^[\p{L} '´`]+$/gu,
      'Solo se permiten caracteres alfabéticos, espacios y apóstrofos.'
    ),
  expiration_date: yup
    .string()
    .required('La cantidad de caracteres ingresados es inválida')
    .min(5, 'La cantidad de caracteres ingresados es inválida')
    .matches(/^(0[1-9]|1[0-2])\/\d{2}$/, 'Ingresa una fecha válida')
    .test(
      'is-future-date',
      'La fecha no puede ser anterior a la fecha de hoy',
      (value) => {
        if (!value) {
          return false;
        }
        const [paramMonth, paramYear] = value.split('/').map(Number);

        const currentDate = new Date();
        const currentMonth = currentDate.getMonth() + 1;
        const currentYear = currentDate.getFullYear() % 100;

        if (
          currentYear < paramYear ||
          (currentYear === paramYear && currentMonth <= paramMonth)
        ) {
          return true;
        }
        return false;
      }
    ),
  installments: yup.number().required(),
  saveCard: yup.boolean().optional(),
  termsAndConditions: yup
    .boolean()
    .required('Deben aceptarse los términos y condiciones.')
    .oneOf([true], 'Deben aceptarse los términos y condiciones.')
});

export { yupResolver } from '@hookform/resolvers/yup';
